import Login from "@/views/Login/Login.vue"
import Painel from "@/views/Painel"
import Home from "@/views/Comum/Home"


export default [
  {
    path: '/login',
    name: 'login',
    components: { nivel1: Login }
  },
  {
    path: '/',
    components: { nivel1: Painel },
    children: [
      {
        path: '/dash',
        components: { nivel2: Home }
      },
      {
        path: '/usuario-list',
        name: 'Usuarios',
        components: { nivel2: () => lazyLoadView(import('@/views/Usuario/ConsultaUsuarios')) },
      },
      {
        path: '/cliente-list',
        name: 'Clientes',
        components: { nivel2: () => lazyLoadView(import('@/views/Cliente/ConsultaClientes')) },
      },
      {
        path: '/acionado-list',
        name: 'Acionados Processos',
        components: { nivel2: () => lazyLoadView(import('@/views/Acionado/ConsultaAcionados')) },
      },
      {
        path: '/statusProcesso-list',
        name: 'Status Processo',
        components: { nivel2: () => lazyLoadView(import('@/views/StatusProcesso/ConsultaStatusProcesso')) },
      },
      {
        path: '/tipoacionado-list',
        name: 'Tipo Acionado',
        components: { nivel2: () => lazyLoadView(import('@/views/TipoAcionado/ConsultaTipoAcionado')) },
      },
      {
        path: '/municipio-list',
        name: 'Municipios',
        components: { nivel2: () => lazyLoadView(import('@/views/Municipio/ConsultaMunicipios')) },
      },
      {
        path: '/colaborador-list',
        name: 'Colaboradores',
        components: { nivel2: () => lazyLoadView(import('@/views/Colaborador/ConsultaColaboradores')) },
      },
      {
        path: '/categoria-list',
        name: 'Categorias',
        components: { nivel2: () => lazyLoadView(import('@/views/Categoria/ConsultaCategorias')) },
      },
      {
        path: '/kit-list',
        name: 'kits',
        components: { nivel2: () => lazyLoadView(import('@/views/Kits/ConsultaKits')) },
      },
      {
        path: '/userkit-files/:id',
        name: 'Kit Files',
        components: { nivel2: () => lazyLoadView(import('@/views/UserKits/ConsultaFileKits')) },
        //props: (route) => ({ query: route.query.q }),
        props: true
      },
      {
        path: '/sinistro-list',
        name: 'Sinistros',
        //components: { nivel2: Home },
        components: { nivel2: () => lazyLoadView(import('@/views/Processo/ConsultaProcessos')) },
      },
      {
        path: '/atendimento-list',
        name: 'Atendimento',
        components: { nivel2: () => lazyLoadView(import('@/views/Atendimento/ConsultaAtendimento')) },
      },
      {
        path: '*',
        redirect: '/dash'
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]



// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@/views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@/views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@/views/Comum/_loading.vue').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@/views/Comum/_timeout.vue').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}


// WEBPACK FOOTER //
// ./src/router/routes.js